import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import dayjs from 'dayjs';
import { BaseSlotComponent } from '../base-slot.component';
import { ZardDatePickerComponent } from '../../../ui/date-picker/date-picker.component';

@Component({
    selector: 'date-slot',
    templateUrl: './date-slot.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        ZardDatePickerComponent
    ],
})
export class DateSlotComponent extends BaseSlotComponent {
    onDateChange(date: Date | null): void {
        if (date) {
            this.formGroup
                .get(this.slot.field)
                .setValue(dayjs(date).format('YYYY-MM-DD'));
        } else {
            this.formGroup
                .get(this.slot.field)
                .setValue(null);
        }
    }
    getValue(): Date | null {
        const value = this.formGroup.get(this.slot.field).value;
        return value ? new Date(value) : null;
    }
}
